var PlayerErrorSeverity = /* @__PURE__ */ ((PlayerErrorSeverity2) => {
  PlayerErrorSeverity2["CRITICAL"] = "CRTICAL";
  PlayerErrorSeverity2["HANDLED"] = "HANDLED";
  PlayerErrorSeverity2["NON_CRITICAL"] = "NON_CRITICAL";
  return PlayerErrorSeverity2;
})(PlayerErrorSeverity || {});
var PlayerErrorCategory = /* @__PURE__ */ ((PlayerErrorCategory2) => {
  PlayerErrorCategory2["NETWORK"] = "NETWORK";
  PlayerErrorCategory2["STREAMING"] = "STREAMING";
  PlayerErrorCategory2["MANIFEST"] = "MANIFEST";
  PlayerErrorCategory2["DRM"] = "DRM";
  PlayerErrorCategory2["OTHER"] = "OTHER";
  return PlayerErrorCategory2;
})(PlayerErrorCategory || {});
var PlayerErrorCode = /* @__PURE__ */ ((PlayerErrorCode2) => {
  PlayerErrorCode2["MALFORMED_DATA_URI"] = "MALFORMED_DATA_URI";
  PlayerErrorCode2["BAD_HTTP_STATUS"] = "BAD_HTTP_STATUS";
  PlayerErrorCode2["HTTP_ERROR"] = "HTTP_ERROR";
  PlayerErrorCode2["TIMEOUT"] = "TIMEOUT";
  PlayerErrorCode2["FILTER_ERROR"] = "FILTER_ERROR";
  PlayerErrorCode2["NETWORK_OTHER"] = "NETWORK_OTHER";
  PlayerErrorCode2["SEGMENT_MISSING"] = "SEGMENT_MISSING";
  PlayerErrorCode2["INVALID_SEGMENT"] = "INVALID_SEGMENT";
  PlayerErrorCode2["MISSING_TEXT_PLUGIN"] = "MISSING_TEXT_PLUGIN";
  PlayerErrorCode2["STREAMING_UNSUPPORTED"] = "STREAMING_UNSUPPORTED";
  PlayerErrorCode2["STREAMING_ERROR"] = "STREAMING_ERROR";
  PlayerErrorCode2["RESTRICTIONS_CANNOT_BE_MET"] = "RESTRICTIONS_CANNOT_BE_MET";
  PlayerErrorCode2["INVALID_MANIFEST"] = "INVALID_MANIFEST";
  PlayerErrorCode2["PERIOD_FLATTENING_FAILED"] = "PERIOD_FLATTENING_FAILED";
  PlayerErrorCode2["INVALID_KEYSYSTEM"] = "INVALID_KEYSYSTEM";
  PlayerErrorCode2["KEYSYSTEM_UNAVAILABLE"] = "KEYSYSTEM_UNAVAILABLE";
  PlayerErrorCode2["DRM_INITIALIZATION_FAILED"] = "DRM_INITIALIZATION_FAILED";
  PlayerErrorCode2["INVALID_SERVER_CERTIFICATE"] = "INVALID_SERVER_CERTIFICATE";
  PlayerErrorCode2["FAILED_TO_GENERATE_LICENSE_REQUEST"] = "FAILED_TO_GENERATE_LICENSE_REQUEST";
  PlayerErrorCode2["LICENSE_REQUEST_FAILED"] = "LICENSE_REQUEST_FAILED";
  PlayerErrorCode2["LICENSE_RESPONSE_REJECTED"] = "LICENSE_RESPONSE_REJECTED";
  PlayerErrorCode2["DRM_INVALID_CONFIG"] = "DRM_INVALID_CONFIG";
  PlayerErrorCode2["LICENSE_EXPIRED"] = "LICENSE_EXPIRED";
  PlayerErrorCode2["SERVER_CERTIFICATE_REQUEST_FAILED"] = "SERVER_CERTIFICATE_REQUEST_FAILED";
  PlayerErrorCode2["DRM_RESTRICTED_OUTPUT"] = "DRM_RESTRICTED_OUTPUT";
  PlayerErrorCode2["OFFLINE_SESSION_REMOVED"] = "OFFLINE_SESSION_REMOVED";
  PlayerErrorCode2["DRM_OTHER"] = "DRM_OTHER";
  PlayerErrorCode2["LOAD_INTERRUPTED"] = "LOAD_INTERRUPTED";
  PlayerErrorCode2["OPERATION_ABORTED"] = "OPERATION_ABORTED";
  PlayerErrorCode2["BAD_PLAYER_INITIALIZATION"] = "BAD_PLAYER_INITIALIZATION";
  PlayerErrorCode2["OBJECT_DESTROYED"] = "OBJECT_DESTROYED";
  PlayerErrorCode2["OTHER"] = "OTHER";
  return PlayerErrorCode2;
})(PlayerErrorCode || {});

export { PlayerErrorCategory, PlayerErrorCode, PlayerErrorSeverity };
//# sourceMappingURL=types.js.map
